import {Component} from '@angular/core';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {MessageSeriesSelected} from '../../messages/message-series-selected';
import {TUPLA_TYPE} from '../../DoraData/data-base';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageRowsSelected} from '../../messages/message-rows-selected';

@Component({
  selector: 'dora-series-from-grid',
  template: ''
})
export class DoraSeriesFromGridComponent extends WidgetBaseGridComponent {

  @DoraProperty
  private reverseSeries = false;

  @DoraProperty
  private invertColumnsRows = false;

  @DoraProperty
  private selectAllRowsOnStart = true;


  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(message => {
      const idRows: string[] = [];

      (message.data as MessageRowsSelected).DataRows.forEach(dataRow => {
        idRows.push(dataRow.Id);
      });

      // select rows
      this.dataGrid.selectRows(idRows);

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.reverseSeries, null, this.invertColumnsRows)), this.CallerName);
    });
  }

  protected onNewData(): void {
    super.onNewData();

    // select all number tuplas
    this.dataGrid.selectColumnsByType(TUPLA_TYPE.NUMBER);

    if (this.selectAllRowsOnStart) {
      // select all rows
      this.dataGrid.selectAllRows();

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.reverseSeries, null, this.invertColumnsRows)), this.CallerName);
    }

  }
}
